import { render, staticRenderFns } from "./trainOverviewModal.vue?vue&type=template&id=4b62e97c&scoped=true&"
import script from "./trainOverviewModal.vue?vue&type=script&lang=js&"
export * from "./trainOverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./trainOverviewModal.vue?vue&type=style&index=0&id=4b62e97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62e97c",
  null
  
)

export default component.exports